// src/Header.js
import React from 'react';

function Header() {
  return (
    <header>
      <h1>Certification Helper</h1>
      
    </header>
  );
}

export default Header;
